import { Typography } from "@mui/material";
import { Loading } from "src/components/utils/Loading";
import { useScoreDetailContext } from "src/context/ScoreDetail/useScoreDetailContext";
import { ModalData } from "../../PropertyModal/PropertyModal";
import { ChartMode } from "../../Chart/chart.types";

import { ByAllHeadings } from "./MainTree/1_byAllHeadings";
import { BySummary } from "./SummaryTree/SummaryEntrypoint";
import { ByHeading } from "./MainTree/2_byHeading";
import { BySubheading } from "./MainTree/3_bySubheading";
import { ByProperties } from "./MainTree/4_byProperties";
import { SummaryDetail } from "./SummaryTree/SummaryDetail";

type HeadingsProps = {
    openModal: (property: ModalData) => void;
    mode: ChartMode;
};
export const HeadingsTree = (props: HeadingsProps) => {
    const { openModal, mode } = props;
    const { scoreDetailBuilder, drilldownState } = useScoreDetailContext();

    if (scoreDetailBuilder === undefined) {
        // Shouldnt happen
        return <Loading />;
    }

    const summary = scoreDetailBuilder.getSummary();
    const isNonMono = summary !== null;

    const stateLength = drilldownState.state.length;
    if (isNonMono) {
        if (stateLength === 0) {
            return <BySummary summary={summary} mode={mode} />;
        }

        const drilldownItem = drilldownState.state[stateLength - 1];
        const isDetail = drilldownItem.type === "detail";
        const detailIndex = drilldownItem.id;
        if (stateLength === 1 && isDetail) {
            return <SummaryDetail summary={summary} detailIndex={detailIndex} mode={mode} />;
        }
    }

    // The drilldownOverhead is used in case additional steps have been added beforehand.
    // Example: Non-monolithic SSQ;
    const additionalOverhead = isNonMono ? 1 : 0;
    const headingsLength = 0 + additionalOverhead;
    const oneHeadingLength = 1 + additionalOverhead;
    const oneSubheadingLength = 2 + additionalOverhead;

    if (stateLength === headingsLength) {
        return <ByAllHeadings scoreDetailBuilder={scoreDetailBuilder} drilldownState={drilldownState} mode={mode} />;
    }

    const headingId = drilldownState.state[headingsLength].id;
    if (stateLength === oneHeadingLength) {
        return <ByHeading headingId={headingId} openModal={openModal} mode={mode} />;
    }

    const drilldownItem = drilldownState.state[oneHeadingLength];
    const isSubheading = drilldownItem.type === "subheadings";
    if (isSubheading) {
        const subheadingId = drilldownItem.id;

        if (stateLength > oneSubheadingLength) {
            const propertyId = drilldownState.state[oneSubheadingLength].id;
            return (
                <ByProperties
                    headingId={headingId}
                    subheadingId={subheadingId}
                    propertyId={propertyId}
                    openModal={openModal}
                    mode={mode}
                />
            );
        }

        return <BySubheading headingId={headingId} subheadingId={subheadingId} openModal={openModal} mode={mode} />;
    }

    const isProperty = drilldownItem.type === "properties";
    if (isProperty) {
        const propertyId = drilldownItem.id;
        return <ByProperties headingId={headingId} propertyId={propertyId} openModal={openModal} mode={mode} />;
    }

    return <Typography variant="big-bold">{"You shouldn't be here"}</Typography>;
};
